import React from "react";

export const Spinner = () => <span className="spin" aria-label="Loading" />;

export const Loading = () => (
  <div className="boot"><Spinner /></div>
);

export function Field({ label, hint, children }) {
  return (
    <label className="field">
      <span>{label}</span>
      {children}
      {hint && <small>{hint}</small>}
    </label>
  );
}

export function Notice({ kind = "info", children }) {
  if (!children) return null;
  return <div className={`notice notice-${kind}`}>{children}</div>;
}

export function Empty({ title, children, action }) {
  return (
    <div className="empty">
      <h2>{title}</h2>
      <p>{children}</p>
      {action}
    </div>
  );
}

export function PageHead({ title, sub, children }) {
  return (
    <div className="page-head">
      <div>
        <h1>{title}</h1>
        {sub && <p>{sub}</p>}
      </div>
      {children}
    </div>
  );
}
